
import { supabase } from '@/integrations/supabase/client';

// Function to delete a user (admin only)
export const deleteUser = async (userId: string) => {
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session) {
    throw new Error('Not authenticated');
  }

  const response = await supabase.functions.invoke('delete-user', {
    body: { userId },
  });

  if (response.error) {
    throw new Error(response.error.message || 'Failed to delete user');
  }

  return response.data;
};
